module.exports = __webpack_public_path__ + "img/bell-gray.14f31c90.svg";